import { render, staticRenderFns } from "./MkProfileDropdown.vue?vue&type=template&id=452b2a6e&scoped=true&"
import script from "./MkProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./MkProfileDropdown.vue?vue&type=script&lang=js&"
import style0 from "@admin/components/organisms/MkHeader/components/MkProfileDropdown.scss?vue&type=style&index=0&id=452b2a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.6_@vue+compiler-sfc@3.5.11_babel-core@7.0.0-bridge.0_@babel+core@7.17.9_f17ab4d8c27c5d7082708fbbc2f82c9d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b2a6e",
  null
  
)

export default component.exports